import { MAX_PAGE_NUMBER } from './maxPageNumber';

export function parsePageParam(raw: string | undefined): number {
	if (raw === undefined || !/^\d+$/.test(raw)) return 1;

	const parsed = Number.parseInt(raw, 10);

	if (parsed < 1) return 1;
	if (parsed > MAX_PAGE_NUMBER) return MAX_PAGE_NUMBER;

	return parsed;
}
